import Requirement from "../../../domains/Requirement";
import requirementDetailsReducer from "./reducer";

export interface RequirementDetailsState {
  requirement: Requirement | null,
  isRequirementLoading: boolean,
  hasErrorLoadingRequirement: boolean,
}

export const initialState: RequirementDetailsState = {
  requirement: null,
  isRequirementLoading: false,
  hasErrorLoadingRequirement: false,
};

export default requirementDetailsReducer;
